/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6d3f4932","_6d3f4932",""]'><div :class='["","_6d3f4932",""]'><div :class='["","_6d3f4932",""]'>switch-position 属性修改 switch 文案位置</div><div :class='["bg-white","_6d3f4932",""]'><cube-collapse :switch-positon="('bottom')" switch-text="查看更多" :min-height="('40px')" :class='["","_6d3f4932",""]'><div :class='["text","_6d3f4932",""]'>1. 吃好喝好</div><div :class='["text","_6d3f4932",""]'>2. 睡前少玩手机</div><div :class='["text","_6d3f4932",""]'>3. 定闹钟早起</div><div :class='["text","_6d3f4932",""]'>4. 上面的理论来自个人猜想</div></cube-collapse></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_6d3f4932"}'>
.bg-white
  margin-top: 6px
  background-color: #fff
.text
  line-height: 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6d3f4932"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6d3f4932"}
  /** script content **/
  require("./change-position.mpx.js?isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-position.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fchange-position6d3f4932%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6d3f4932"],
    ctorType: "component",
    outputPath: "components/change-position6d3f4932/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-collapse':getComponent(require("../../../packages/mpx-cube-ui/src/components/collapse/index.mpx?isComponent&outputPath=components%2Findex5127b398%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>